<template>
  <page>
    <!-- Keep for further need or enhancement -->
    <!-- <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div> -->
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl3 lg6 xs6>
                          <v-autocomplete
                            :items="docTypeList"
                            item-text="label"
                            item-value="value"
                            v-model="filters.docType"
                            :label="labels.docType"
                            :error-messages="errors.collect('docType')"
                            data-vv-name="docType"
                            :data-vv-as="labels.docType"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xl3 lg6 xs6>
                          <v-autocomplete
                            :items="formIdList"
                            item-text="label"
                            item-value="value"
                            v-model="filters.formId"
                            :label="labels.formId"
                            :error-messages="errors.collect('formId')"
                            data-vv-name="formId"
                            :data-vv-as="labels.formId"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xl3 lg4 xs4>
                          <v-text-field
                            v-model="filters.keyFact1Type"
                            :label="labels.keyFact1Type"
                            :error-messages="errors.collect('keyFact1Type')"
                            data-vv-scope="filter"
                            data-vv-name="keyFact1Type"
                            :data-vv-as="labels.keyFact1Type"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs4>
                          <v-text-field
                            v-model="filters.keyFact2Type"
                            :label="labels.keyFact2Type"
                            :error-messages="errors.collect('keyFact2Type')"
                            data-vv-scope="filter"
                            data-vv-name="keyFact2Type"
                            :data-vv-as="labels.keyFact2Type"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs4>
                          <v-text-field
                            v-model="filters.keyFact3Type"
                            :label="labels.keyFact3Type"
                            :error-messages="errors.collect('keyFact3Type')"
                            data-vv-scope="filter"
                            data-vv-name="keyFact3Type"
                            :data-vv-as="labels.keyFact3Type"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xl3 lg4 xs4>
                          <v-text-field
                            v-model="filters.keyFact4Type"
                            :label="labels.keyFact4Type"
                            :error-messages="errors.collect('keyFact4Type')"
                            data-vv-scope="filter"
                            data-vv-name="keyFact4Type"
                            :data-vv-as="labels.keyFact4Type"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs4>
                          <v-text-field
                            v-model="filters.keyFact5Type"
                            :label="labels.keyFact5Type"
                            :error-messages="errors.collect('keyFact5Type')"
                            data-vv-scope="filter"
                            data-vv-name="keyFact5Type"
                            :data-vv-as="labels.keyFact5Type"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs4>
                          <v-text-field
                            v-model="filters.keyFact6Type"
                            :label="labels.keyFact6Type"
                            :error-messages="errors.collect('keyFact6Type')"
                            data-vv-scope="filter"
                            data-vv-name="keyFact6Type"
                            :dat-vv-as="labels.keyFact6Type"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-layout row>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mr-2" @click="doNew()"> New Doc No. Format<v-icon right>mdi-plus</v-icon> </v-btn>
            <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
              <template v-slot:activator="{ on }">
                <v-btn color="secondary" class="white--text" v-on="on">
                  <span>Columns</span>
                  <v-icon right dark>mdi-table-column-plus-after</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-text>
                  <template v-if="columns.length > 0">
                    <v-checkbox
                      v-for="column in columns"
                      :key="column.value"
                      :label="column.text"
                      :value="column.value"
                      v-model="selectedColumns"
                    ></v-checkbox>
                  </template>
                  <template v-else> No column found </template>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-layout>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table
              item-key
              :headers="listHeaders"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              class="elevation-1"
              :footer-props="{ 'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td v-for="column in selectedColumns" :key="column">
                    {{ getColumnVal(row.item[column], column) }}
                  </td>
                  <td class="table-action-header">
                    <table-action
                      v-if="row.item.docType == 'V' || row.item.docType == 'H'"
                      :rowData="row"
                      query
                      @query="doAction(row.item)"
                    ></table-action>
                    <table-action v-else :rowData="row" query @query="doAction(row.item)" remove @remove="doPromptRemove"></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">Please confirm deletion of this records.</confirm>
      <v-dialog v-model="docNoFormReview" width="900px" scrollable persistent>
        <docno-form-review
          :docNoFormForm="docNoFormForm"
          :newDocNoForm="newDocNoForm"
          @close="doClose"
          :visible="docNoFormReview"
          :viewLayoutForm="layoutForm"
        ></docno-form-review>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import DocnoFormReview from './DocNoFormReview'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { docNoFormMixin } from './docNoFormMixin'

// Keep for further need or enhancement
// import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Clause',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'clause' }
        },
        {
          text: 'Default Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'defText' }
        },
        {
          text: 'Document Heading Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docHdgTxtList' }
        },
        {
          text: 'Seq No., Various',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'docNoSeq' }
        },
        {
          text: 'Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'stdRiskTxtList' }
        }
      ],
      toogleArray: [false],
      columns: [
        { text: 'Document Type', align: 'left', value: 'docType' },
        { text: 'Format Desc', value: 'formDesc' },
        { text: 'Format ID', value: 'formId' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Key Factor 1 Type', value: 'keyFact1Type' },
        { text: 'Key Factor 2 Type', value: 'keyFact2Type' },
        { text: 'Key Factor 3 Type', value: 'keyFact3Type' },
        { text: 'Key Factor 4 Type', value: 'keyFact4Type' },
        { text: 'Key Factor 5 Type', value: 'keyFact5Type' },
        { text: 'Key Factor 6 Type', value: 'keyFact6Type' }
      ],
      selectedColumns: ['docType', 'formDesc', 'formId', 'effDate'],
      labels: {
        docType: 'Document Type',
        formId: 'Format ID',
        keyFact1Type: 'Key Factor 1 Type',
        keyFact2Type: 'Key Factor 2 Type',
        keyFact3Type: 'Key Factor 3 Type',
        keyFact4Type: 'Key Factor 4 Type',
        keyFact5Type: 'Key Factor 5 Type',
        keyFact6Type: 'Key Factor 6 Type'
      },
      filters: {
        docType: null,
        formId: null,
        keyFact1Type: null,
        keyFact2Type: null,
        keyFact3Type: null,
        keyFact4Type: null,
        keyFact5Type: null,
        keyFact6Type: null
      },
      loading: false,
      docNoFormForm: {
        docType: null,
        formId: null,
        formDesc: null,
        effDate: null,
        keyFact1Type: null,
        keyFact2Type: null,
        keyFact3Type: null,
        keyFact4Type: null,
        keyFact5Type: null,
        keyFact6Type: null,
        inclFact1seqNo: false,
        inclFact2seqNo: false,
        inclFact3seqNo: false,
        inclFact4seqNo: false,
        inclFact5seqNo: false,
        inclFact6seqNo: false,
        createdName: '',
        createdDate: null,
        modifiedName: '',
        modifiedDate: null
      },
      totalItems: 0,
      newDocNoForm: false,
      docNoFormReview: false,
      selectedDocNoForm: {},
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    pagination: function (value) {
      this.doInit(false)
    }
  },
  computed: {
    menu() {
      return this.$store.state.docFormatParam.menu
    },
    docTypeList() {
      return [
        { label: 'C - Claim No.', value: 'C' },
        { label: 'P - Policy No.', value: 'P' },
        { label: 'V - Voyage No.', value: 'V' },
        { label: 'H - Vessel No.', value: 'H' }
      ]
    },
    formIdList() {
      return [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
        { label: '07', value: 7 },
        { label: '08', value: 8 },
        { label: '09', value: 9 },
        { label: '10', value: 10 }
      ]
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find((a) => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  methods: {
    async doInit(options) {
      const apiURI = this.menu.getDocNoFormPage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((docNoSeq) => {
                const convertList = {
                  docType: docNoSeq.docType,
                  formId: docNoSeq.formId,
                  effDate: docNoSeq.effDate,
                  formDesc: docNoSeq.formDesc,
                  keyFact1Type: docNoSeq.keyFact1Type,
                  keyFact2Type: docNoSeq.keyFact2Type,
                  keyFact3Type: docNoSeq.keyFact3Type,
                  keyFact4Type: docNoSeq.keyFact4Type,
                  keyFact5Type: docNoSeq.keyFact5Type,
                  keyFact6Type: docNoSeq.keyFact6Type
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    getColumnVal(colVal, col) {
      if (col === 'docType') {
        return this.convertDocType(colVal)
      } else if (col === 'effDate') {
        return this.formatDisplayDate(colVal)
      } else {
        return colVal
      }
    },
    formatDisplayDate(xDate) {
      if (xDate) {
        return formatDisplayDate(xDate)
      } else {
        return undefined
      }
    },
    convertDocType(field) {
      if (field === 'P') {
        return 'Policy No.'
      } else if (field === 'C') {
        return 'Claims No.'
      } else if (field === 'V') {
        return 'Voyage No.'
      } else {
        return 'Vessel No.'
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.docType = null
      this.filters.formId = null
      this.filters.keyFact1Type = null
      this.filters.keyFact2Type = null
      this.filters.keyFact3Type = null
      this.filters.keyFact4Type = null
      this.filters.keyFact5Type = null
      this.filters.keyFact6Type = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filter').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    async doAction(listData) {
      this.resetMessages()
      const apiURI = this.menu.getDocNoForm
      if (apiURI) {
        this.loading = true
        const result = await this.$http.post(apiURI, listData)
        const { data } = result.data
        if (data) {
          this.docNoFormForm.docType = data.docNoForm.docType
          this.docNoFormForm.formId = data.docNoForm.formId
          this.docNoFormForm.effDate = data.docNoForm.effDate
          this.docNoFormForm.formDesc = data.docNoForm.formDesc
          this.docNoFormForm.keyFact1Type = data.docNoForm.keyFact1Type
          this.docNoFormForm.keyFact2Type = data.docNoForm.keyFact2Type
          this.docNoFormForm.keyFact3Type = data.docNoForm.keyFact3Type
          this.docNoFormForm.keyFact4Type = data.docNoForm.keyFact4Type
          this.docNoFormForm.keyFact5Type = data.docNoForm.keyFact5Type
          this.docNoFormForm.keyFact6Type = data.docNoForm.keyFact6Type
          this.docNoFormForm.inclFact1seqNo = data.docNoForm.inclFact1seqNo
          this.docNoFormForm.inclFact2seqNo = data.docNoForm.inclFact2seqNo
          this.docNoFormForm.inclFact3seqNo = data.docNoForm.inclFact3seqNo
          this.docNoFormForm.inclFact4seqNo = data.docNoForm.inclFact4seqNo
          this.docNoFormForm.inclFact5seqNo = data.docNoForm.inclFact5seqNo
          this.docNoFormForm.inclFact6seqNo = data.docNoForm.inclFact6seqNo
          this.docNoFormForm.createdName = data.docNoForm.createdName
          this.docNoFormForm.createdDate = data.docNoForm.createdDate
          this.docNoFormForm.modifiedName = data.docNoForm.modifiedName
          this.docNoFormForm.modifiedDate = data.docNoForm.modifiedDate
          this.doInitDocNoForm(this.docNoFormForm)
        }
        // this.loading = false
      }
    },
    doNew() {
      this.docNoFormForm.formDesc = undefined
      this.newDocNoForm = true
      this.docNoFormReview = true
    },
    doClose() {
      this.docNoFormReview = false
      this.doInit(false)
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedDocNoForm = data.item
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.menu.deleteDocNoForm
      if (apiURI) {
        const expand = this.selectedDocNoForm
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  mounted() {
    this.doInit(true)
  },
  components: {
    DocnoFormReview

    // Keep for further need or enhancement
    // SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin, docNoFormMixin]
}
</script>

<style lang="scss">
</style>
